import createInvoiceSprites from 'assets/images/CreateInvoice_Spritesheet.png';
import createQuoteSprites from 'assets/images/Create_quote_spritesheet.png';
import dropzoneOnboardingGif from 'assets/images/Dropzone_Preview.gif';
import dropzoneOnboardingStatic from 'assets/images/Dropzone_Static_2x.png';
import encodeRevenueSprites from 'assets/images/EncodeRevenue_Spritesheet.png';
import expensesOnboardingCard1 from 'assets/images/expensesOnboardingCard1.png';
import expensesOnboardingCard2 from 'assets/images/expensesOnboardingCard2.png';
import expensesOnboardingCard3 from 'assets/images/expensesOnboardingCard3.png';
import repositoryOnboardingImg1 from 'assets/images/repository-onboarding-1.png';
import revenuesOnboardingCard1 from 'assets/images/revenuesOnboardingCard1.png';
import revenuesOnboardingCard2 from 'assets/images/revenuesOnboardingCard2.png';
import revenuesOnboardingCard3 from 'assets/images/revenuesOnboardingCard3.png';
// import createInvoiceImageGif from 'assets/images/CreateInvoice_Preview.gif';
// import createInvoiceImageStatic from 'assets/images/CreateInvoice_Static_2x.png';
// import encodeRevenuesImageGif from 'assets/images/EncodeRevenue_Preview.gif';
// import encodeRevenuesImageStatic from 'assets/images/EncodeRevenue_Static_2x.png';
// import taxesOnboardingImg from 'assets/images/taxesOnboarding.png';
import walletBannerGraphics from 'assets/images/accountable-wallet-banner-graphic.png';
import accountableWalletGraphic from 'assets/images/accountable-wallet-graphic.png';
import bnpLogo from 'assets/images/bnp-logo.png';
import belfiusBankLogo from 'assets/images/mastercard-belfius-logo.png';
import commerzBankLogo from 'assets/images/mastercard-commerzbank-logo.png';
import DKBBankLogo from 'assets/images/mastercard-dkb-bank-logo.png';
import ingBankLogo from 'assets/images/mastercard-ing-logo.png';
import KBCBankLogo from 'assets/images/mastercard-kbc-logo.png';
import postBankLogo from 'assets/images/mastercard-postbank-logo.png';
import repositoryOnboardingImg3 from 'assets/images/repository-onboarding-3.png';
import swanLogo from 'assets/images/swan-logo.png';
import transactionsOnboardingCard1 from 'assets/images/transactionsOnboardingCard1.png';
import transactionsOnboardingCard2 from 'assets/images/transactionsOnboardingCard2.png';
import transactionsOnboardingCard3 from 'assets/images/transactionsOnboardingCard3.png';
import walletOnboardingImg1 from 'assets/images/wallet-onboarding-1.png';
import walletOnboardingImg2 from 'assets/images/wallet-onboarding-2.png';
import walletOnboardingImg3 from 'assets/images/wallet-onboarding-3.png';
import accountableCardImg from 'assets/images/new_accountable_card.svg';
import automateTaxesIllustrationDE from 'assets/images/wallet-onboarding-automate-taxes-de.png';
import automateTaxesIllustrationFR from 'assets/images/wallet-onboarding-automate-taxes-fr.png';
import automateTaxesIllustrationNL from 'assets/images/wallet-onboarding-automate-taxes-nl.png';
import automateTaxesIllustration from 'assets/images/wallet-onboarding-automate-taxes.png';
import bonusIllustration from 'assets/images/wallet-onboarding-bonus.png';
import invoiceBonusImgBE_EN from 'assets/images/wallet-onboarding-invoice-bonus-be-en.png';
import invoiceBonusImgBE_FR from 'assets/images/wallet-onboarding-invoice-bonus-be-fr.png';
import invoiceBonusImgBE_NL from 'assets/images/wallet-onboarding-invoice-bonus-be-nl.png';
import invoiceBonusImgDE_DE from 'assets/images/wallet-onboarding-invoice-bonus-de-de.png';
import invoiceBonusImgDE_EN from 'assets/images/wallet-onboarding-invoice-bonus-de-en.png';
import mainAccountIllustration from 'assets/images/wallet-onboarding-main-account.png';
import savingsAccountIllustration from 'assets/images/wallet-onboarding-savings-account.png';
import shieldIllustration from 'assets/images/wallet-onboarding-shield.png';

const images = [
  walletBannerGraphics,
  accountableWalletGraphic,
  bnpLogo,
  swanLogo,
  bonusIllustration,
  shieldIllustration,
  expensesOnboardingCard1,
  expensesOnboardingCard2,
  expensesOnboardingCard3,
  repositoryOnboardingImg1,
  repositoryOnboardingImg3,
  dropzoneOnboardingStatic,
  dropzoneOnboardingGif,
  createInvoiceSprites,
  encodeRevenueSprites,
  createQuoteSprites,
  revenuesOnboardingCard1,
  revenuesOnboardingCard2,
  revenuesOnboardingCard3,
  transactionsOnboardingCard1,
  transactionsOnboardingCard2,
  transactionsOnboardingCard3,
  walletOnboardingImg1,
  walletOnboardingImg2,
  walletOnboardingImg3,
  belfiusBankLogo,
  commerzBankLogo,
  DKBBankLogo,
  ingBankLogo,
  KBCBankLogo,
  postBankLogo,
  accountableCardImg,
  mainAccountIllustration,
  savingsAccountIllustration,
  automateTaxesIllustration,
  automateTaxesIllustrationDE,
  automateTaxesIllustrationFR,
  automateTaxesIllustrationNL,
  invoiceBonusImgBE_EN,
  invoiceBonusImgBE_FR,
  invoiceBonusImgBE_NL,
  invoiceBonusImgDE_DE,
  invoiceBonusImgDE_EN,
];

let done = false;

const prefetchOnboardingImages = () => {
  if (done) return;
  done = true;
  images.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
};

export default prefetchOnboardingImages;
